/**
 * Constants
 * */
export const moduleName = `cartInfo`;

/**
 * Reducer
 * */

export default function reducer(state = {}, action) {
  const {type} = action;

  switch (type) {
    default:
      return state;
  }
}

/**
 * Selectors
 * */

export const cartInfoSelector = (state) => state[moduleName];

/**
 * Action Creators
 * */
